@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="false"></loading>
} @else if (username) {
    <div class="flex flex-col sm:flex-row gap-2 justify-center">
        <!-- Nav -->
        <div class="flex flex-col text-sm p-2 sm:pt-4">
            <div class="bg-slate-100 rounded-md shadow w-full sm:w-64">
                <div class="bg-ponder-light rounded-t-md p-2 pr-8 text-slate-50 text-base shadow">
                    Account Settings
                </div>
                <user-account-category-button label="General"  [svgIcon]="svgIcons.Settings" [category]="settingsCategories.General" [isSelected]="true"></user-account-category-button>
                <user-account-category-button label="Security" [svgIcon]="svgIcons.LockClosed" [category]="settingsCategories.Security"></user-account-category-button>
                <user-account-category-button label="Billing" [svgIcon]="svgIcons.CreditCard" [category]="settingsCategories.Billing" [isLast]="true"></user-account-category-button>
            </div>
        </div>
        <!-- Display -->
        <div class="flex flex-col w-[360px] sm:min-w-[360px] sm:max-w-[720px] grow">
            <router-outlet></router-outlet>
        </div>
    </div>
} @else {
    <unauthorized></unauthorized>
}